import * as XLSX from 'xlsx';
import { ShippingRecord } from '../../types';
import { getDestinationDisplay } from './shippingSort';
import { formatDate } from '../dateFormatter';

interface ExportFilters {
  licensePlate: string;
  shippingAddress: string;
  province: string;
}

export const exportShippingRecordsToExcel = (
  records: ShippingRecord[], 
  filters: ExportFilters
): void => {
  // Filter created records
  const createdRecords = records.filter(record => {
    const matchesLicense = !filters.licensePlate || record.licensePlate === filters.licensePlate;
    const matchesAddress = !filters.shippingAddress || record.shippingAddress.toLowerCase().includes(filters.shippingAddress.toLowerCase());
    const matchesProvince = !filters.province || record.provinceName === filters.province;
    // Note: status field is not in ShippingRecord type definition, but exists in API response
    const isCreated = record.status === 'created';
    return matchesLicense && matchesAddress && matchesProvince && isCreated;
  });

  if (createdRecords.length === 0) {
    alert('No created records to export');
    return;
  }

  // Group records by license plate
  const groupedByLicensePlate = createdRecords.reduce((acc, record) => {
    const plate = record.licensePlate;
    if (!acc[plate]) {
      acc[plate] = [];
    }
    acc[plate].push(record);
    return acc;
  }, {} as Record<string, ShippingRecord[]>);

  // Create workbook
  const workbook = XLSX.utils.book_new();

  // For each license plate, create a sheet
  Object.entries(groupedByLicensePlate).forEach(([licensePlate, plateRecords]) => {
    const worksheetData = plateRecords.map((record, index) => ({
      'STT': index + 1,
      'Ngày': formatDate(record.shippingDate),
      'Xe Tải': record.licensePlate,
      'Địa điểm đến': getDestinationDisplay(record),
      'Nơi đi': record.provinceName || '-',
      'Giá': record.shippingCost,
      'Tạm ứng': record.prepaidAmount,
      'Bốc Xếp': record.loadUnloadFee,
      'Trạm thu phí': record.tollFee,
      'Tiền dầu': record.fuelCost,
      'RM2': record.rM2Fee,
      'Sửa chữa': record.repairCost
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Clean license plate for sheet name (remove invalid characters)
    const sheetName = licensePlate.replace(/[\\/'?*[\]]/g, '_').substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  // Save file
  const fileName = `shipping-records-${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};
